<template>
  <div class="proveedores-wrapper">
    <ModalLoading :isLoading="isLoading" />

    <div class="opciones">
      <button
        v-if="puedeCrearProveedor"
        id="btnAdd"
        class="btn btn-primary"
        @click="openModal"
        style="width: 200px; white-space: nowrap"
      >
        Agregar Proveedor
      </button>

      <div class="search-bar">
        <input
          class="busqueda"
          type="text"
          v-model="searchQuery"
          placeholder="Buscar proveedor..."
        />
      </div>
    </div>

    <div class="table-container">
      <!-- Indicador de carga -->
      <div v-if="isLoading" class="loading-indicator">
        Cargando proveedores...
      </div>

      <!-- Mensaje si no hay datos -->
      <div v-else-if="paginatedProveedores.length === 0" class="no-data">
        No se encontraron proveedores para mostrar.
      </div>

      <table v-else class="table">
        <thead>
          <tr>
            <th class="col-id">#</th>
            <th class="col-nombre">Nombre</th>
            <th class="col-rtn">RTN</th>
            <th class="col-telefono">Teléfono</th>
            <th class="col-email">Email</th>
            <th class="col-direccion">Dirección</th>
            <th v-if="puedeAccionesProveedor" class="col-acciones">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(proveedor, index) in paginatedProveedores" :key="index">
            <td data-label="#">
              {{ (currentPage - 1) * pageSize + index + 1 }}
            </td>
            <td data-label="Nombre">{{ proveedor.nombre }}</td>
            <td data-label="RTN">{{ proveedor.rtn || "N/A" }}</td>
            <td data-label="Teléfono">{{ proveedor.telefono }}</td>
            <td data-label="Email">{{ proveedor.correo }}</td>
            <td data-label="Dirección">{{ proveedor.direccion }}</td>
            <td v-if="puedeAccionesProveedor" data-label="Acciones">
              <button
                v-if="puedeEditarProveedor"
                class="accion-btn btn-editar"
                @click="editProveedor(proveedor)"
                title="Editar proveedor"
              >
                <i class="bi bi-pencil-fill"></i>
              </button>
              <button
                v-if="puedeEliminarProveedor"
                class="accion-btn btn-eliminar"
                @click="deleteProveedor(proveedor)"
                title="Eliminar proveedor"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginación -->
      <div class="pagination-wrapper">
        <div class="pagination-info">
          Mostrando
          {{
            paginatedProveedores.length === 0
              ? 0
              : (currentPage - 1) * pageSize + 1
          }}
          a
          {{ Math.min(currentPage * pageSize, filteredProveedores.length) }}
          de {{ filteredProveedores.length }} registros
        </div>
        <div class="pagination-container">
          <button
            class="pagination-button"
            :disabled="currentPage === 1"
            @click="previousPage"
          >
            Anterior
          </button>
          <button
            class="pagination-button"
            :disabled="currentPage === totalPages || totalPages === 0"
            @click="nextPage"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>

    <div class="modal" v-if="showConfirmModal">
      <div class="modal-confirm">
        <div class="modal-header">
          <h2>Confirmación</h2>
        </div>

        <div class="modal-body-confirm">
          <p>¿Estás seguro de que quieres eliminar este proveedor?</p>
        </div>

        <div class="modal-footer">
          <div class="action-buttons">
            <btnGuardarModal
              texto="Sí, eliminar"
              style="background-color: red"
              @click="deleteProveedor()"
            />
            <btnCerrarModal texto="No, regresar" @click="cancelDelete" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para agregar o editar proveedores -->
    <div v-if="isModalOpen" class="modal">
      <div class="modal-proveedores">
        <div class="modal-header">
          <h2 class="h2-modal-proveedores">
            {{ isEditing ? "Editar Proveedor" : "Agregar Proveedor" }}
          </h2>
        </div>

        <div class="modal-body">
          <div class="contenedor">
            <div class="form-group">
              <label>Nombre:</label>
              <input
                ref="nombreInput"
                v-model="proveedorForm.nombre"
                type="text"
                required
              />
            </div>

            <!-- ✅ NUEVO CAMPO RTN -->
            <div class="form-group">
              <label>RTN (Registro Tributario Nacional):</label>
              <input
                v-model="proveedorForm.rtn"
                type="text"
                placeholder="08011990123456 (14 dígitos)"
                maxlength="14"
                @input="formatRTN"
              />
              <small class="help-text"
                >Formato: 14 dígitos sin guiones ni espacios</small
              >
            </div>

            <div class="form-group">
              <label>Teléfono:</label>
              <div class="phone-input-container">
                <select
                  v-model="selectedCountry"
                  @change="updatePhoneValidation"
                  class="select-phone"
                >
                  <option value="">País</option>
                  <option
                    v-for="(country, code) in countryData"
                    :key="code"
                    :value="code"
                  >
                    {{ country.emoji }} {{ country.code }}
                  </option>
                </select>
                <input
                  v-model="proveedorForm.telefono"
                  type="text"
                  class="input-phone"
                  :placeholder="'Número (' + phoneLength + ' dígitos)'"
                  required
                />
              </div>
            </div>

            <div class="form-group">
              <label>Email:</label>
              <input v-model="proveedorForm.correo" type="text" required />
            </div>

            <div class="form-group">
              <label>Dirección:</label>
              <input v-model="proveedorForm.direccion" type="text" required />
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="action-buttons">
            <btnGuardarModal
              :texto="isEditing ? 'Guardar Cambios' : 'Agregar Proveedor'"
              @click="guardarProveedor"
            >
            </btnGuardarModal>
            <btnCerrarModal
              :texto="'Cerrar'"
              @click="closeModal"
            ></btnCerrarModal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import btnGuardarModal from "../components/botones/modales/btnGuardar.vue";
import btnCerrarModal from "../components/botones/modales/btnCerrar.vue";
import { notis } from "../../services/notificaciones.js";
const { esCeo } = require("../../services/usuariosSolicitudes");
import { hasAccionPermiso } from '../../services/permisos.js';
import { COUNTRY_CODES } from "../../services/countrySelector.js";
import { validacionesProveedores } from "../../services/validarCampos.js";
import solicitudes from "../../services/solicitudes.js";
import ModalLoading from "@/components/ModalLoading.vue";
import { setPageTitle } from "@/components/pageMetadata";
const { getSocket } = require('@/services/socket');

export default {
  name: "AdministrarProveedores",
  components: {
    btnGuardarModal,
    btnCerrarModal,
    ModalLoading,
  },
  data() {
    return {
      titulo: "Proveedores",
      isLoading: false,
      showConfirmModal: false,
      proveedorToDelete: null,
      searchQuery: "",
      isModalOpen: false,
      isEditing: false,
      editIndex: null,
      id_usuario: 0,
      currentPage: 1,
      pageSize: 10,
      esCeo: false,
      selectedCountry: "HN",
      countryData: COUNTRY_CODES,
      phoneLength: 8,
      proveedorForm: {
        nombre: "",
        rtn: "", // ✅ Campo RTN agregado
        telefono: "",
        correo: "",
        direccion: "",
      },
      proveedores: [],
    };
  },

  computed: {
    puedeCrearProveedor()    { return hasAccionPermiso('proveedores_crear'); },
    puedeEditarProveedor()   { return hasAccionPermiso('proveedores_editar'); },
    puedeEliminarProveedor() { return hasAccionPermiso('proveedores_eliminar'); },
    puedeAccionesProveedor() { return this.puedeEditarProveedor || this.puedeEliminarProveedor; },
    filteredProveedores() {
      return this.proveedores.filter(
        (proveedor) =>
          proveedor.nombre
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          proveedor.telefono.includes(this.searchQuery) ||
          (proveedor.rtn && proveedor.rtn.includes(this.searchQuery))
      );
    },

    paginatedProveedores() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredProveedores.slice(startIndex, endIndex);
    },

    totalPages() {
      return Math.ceil(this.filteredProveedores.length / this.pageSize);
    },
  },

  methods: {
    // ✅ Nuevo método para formatear RTN
    formatRTN() {
      // Remover cualquier carácter que no sea número
      this.proveedorForm.rtn = this.proveedorForm.rtn.replace(/\D/g, "");
    },

    // ✅ Nuevo método para validar RTN
    validarRTN(rtn) {
      if (!rtn) return true; // RTN es opcional

      // Debe tener exactamente 14 dígitos
      if (rtn.length !== 14) {
        notis("error", "El RTN debe tener exactamente 14 dígitos");
        return false;
      }

      // Solo números
      if (!/^\d+$/.test(rtn)) {
        notis("error", "El RTN solo debe contener números");
        return false;
      }

      return true;
    },

    updatePhoneValidation() {
      if (this.selectedCountry && this.countryData[this.selectedCountry]) {
        this.phoneLength = this.countryData[this.selectedCountry].length;
      }
    },

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    async loadProveedores() {
      this.isLoading = true;
      try {
        this.proveedores = await solicitudes.fetchRegistrosAuth(
          `/proveedores/${this.id_usuario}`
        );
      } catch (error) {
        notis("error", error.message);
      } finally {
        this.isLoading = false;
      }
    },

    openModal() {
      this.isModalOpen = true;
      this.$nextTick(() => {
        this.$refs.nombreInput?.focus();
      });
    },

    closeModal() {
      this.isModalOpen = false;
      this.clearForm();
    },

    clearForm() {
      this.proveedorForm = {
        nombre: "",
        rtn: "", // ✅ Incluir RTN al limpiar
        telefono: "",
        correo: "",
        direccion: "",
      };
      this.isEditing = false;
      this.editIndex = null;
    },

    async guardarProveedor() {
      // ✅ Validar RTN antes de continuar
      if (!this.validarRTN(this.proveedorForm.rtn)) {
        return;
      }

      if (
        !validacionesProveedores.validarCampos(
          this.proveedorForm,
          this.selectedCountry
        )
      ) {
        return;
      }

      this.isLoading = true;

      this.proveedorForm.id_usuario = this.id_usuario;
      let response;
      let parametros;

      if (this.isEditing) {
        try {
          parametros = `/proveedores/actualizar-proveedor/${
            this.proveedores[this.editIndex].id
          }`;
          response = await solicitudes.patchRegistroAuth(
            parametros,
            this.proveedorForm
          );

          if (response === true) {
            this.isLoading = false;
            notis("success", "Actualizando datos del proveedor...");
            Object.assign(this.proveedores[this.editIndex], this.proveedorForm);
          } else {
            notis("error", response.message);
          }
        } catch (error) {
          notis("error", error.message);
        } finally {
          this.isLoading = false;
        }
      } else {
        try {
          parametros = `/proveedores/crear-proveedor/${this.id_usuario}`;
          response = await solicitudes.postRegistroAuth(
            parametros,
            this.proveedorForm
          );

          if (response && response.id) {
            this.isLoading = false;
            notis("success", "Proveedor guardado correctamente...");
            this.proveedores.push(response);
          } else {
            throw new Error(response?.message || "Error al crear el proveedor.");
          }
        } catch (error) {
          notis("error", error.message);
        } finally {
          this.isLoading = false;
        }
      }
      this.closeModal();
    },

    editProveedor(proveedor) {
      this.proveedorForm = { ...proveedor };
      this.isEditing = true;
      this.editIndex = this.proveedores.findIndex(
        (item) => item.id === proveedor.id
      );
      this.openModal();
      this.$nextTick(() => {
        this.$refs.nombreInput?.focus();
      });
    },

    async deleteProveedor(proveedor) {
      if (!this.showConfirmModal) {
        this.proveedorToDelete = proveedor;
        this.showConfirmModal = true;
        return;
      }
      this.isLoading = true;

      try {
        const datosActualizados = {
          estado: false,
          id_usuario: this.id_usuario,
        };

        const parametros = `/proveedores/desactivar-proveedor/${this.proveedorToDelete.id}`;
        const response = await solicitudes.desactivarRegistro(
          parametros,
          datosActualizados
        );

        if (response === true) {
          this.proveedores = this.proveedores.filter(
            (item) => item.id !== this.proveedorToDelete.id
          );
          notis("success", "Proveedor eliminado correctamente");
        }
      } catch (error) {
        notis(
          "error",
          "Error al eliminar el proveedor, hay productos asignados con el proveedor"
        );
      } finally {
        this.showConfirmModal = false;
        this.proveedorToDelete = null;
        this.isLoading = false;
      }
    },

    cancelDelete() {
      this.showConfirmModal = false;
      this.proveedorToDelete = null;
    },

    changeFavicon(iconPath) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = iconPath;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
  },

  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
  },

  async mounted() {
    this.isLoading = true;
    setPageTitle("Proveedores");

    try {
      this.id_usuario = await solicitudes.solicitarUsuarioToken();
      await this.loadProveedores();
      this.esCeo = await esCeo(this.id_usuario);
    } catch (error) {
      notis("error", error.message);
    } finally {
      this.isLoading = false;
    }
    const _s = getSocket();
    if (_s) {
      this._wsRefresh = () => { if (this.id_usuario) this.loadProveedores(); };
      _s.on('proveedores:refresh', this._wsRefresh);
    }
  },
  beforeUnmount() {
    const _s = getSocket();
    if (_s && this._wsRefresh) _s.off('proveedores:refresh', this._wsRefresh);
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

/* Fuentes */
* {
  font-family: "Montserrat", sans-serif;
  box-sizing: border-box;
}

.modal {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-confirm {
  background: white;
  border-radius: 12px;
  width: 25%;
  max-width: 1000px;
  max-height: 90vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin: 20px;
  overflow: hidden;
}

.modal-body-confirm {
  padding: 24px;
  overflow-y: auto;
  background-color: white;
}

.modal-proveedores {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin: 20px;
  overflow: hidden;
}

.dark .modal-usuario {
  background-color: #2d2d2d;
  color: #fff;
}

.modal-header {
  padding: 24px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
}

.dark .modal-header,
.dark .modal-footer {
  background-color: #1e1e1e;
  border-color: #404040;
}

.dark .modal-header h2 {
  color: #fff;
}

.modal-body {
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding: 24px;
  overflow-y: auto;
}

.modal-body-confirm {
  padding: 24px;
  overflow-y: auto;
  background-color: white;
}

.dark .modal-body-confirm {
  background-color: #333;
}

.contenedor {
  width: 90%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: 500;
}

/* ✅ Nuevo estilo para el texto de ayuda */
.help-text {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}

.dark .help-text {
  color: #aaa;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  background-color: white;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #c09d62;
  box-shadow: 0 0 0 3px rgba(192, 157, 98, 0.2);
}

.dark .form-group label {
  color: #fff;
}

.dark .form-group input,
.dark .form-group textarea,
.dark .form-group select {
  background-color: #383838;
  border-color: #404040;
  color: #fff;
}

.dark .form-group input,
.dark .form-group select {
  background-color: #383838;
  border-color: #404040;
  color: #fff;
}

.modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
}

/* Opciones */
.opciones {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.registros {
  height: 100%;
  padding-bottom: 1%;
  flex-grow: 1;
  min-width: 200px;
}

/* Selección personalizada */
.custom-select {
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 35px;
  font-size: 16px;
  padding: 5px;
  background-color: #fff;
  cursor: pointer;
  width: 80px;
}

/* Botones */
#btnAdd {
  background-color: #c09d62;
  font-size: 16px;
  width: 200px;
  height: 40px;
  border-radius: 10px;
  color: black;
  font-weight: bold;
  transition: all 0.3s ease;
  white-space: nowrap;
}

#btnAdd:hover {
  background-color: #a38655;
  transform: scale(1.05);
}

/* Botón de edición */
#btnEditar {
  font-size: 18px;
  width: 50px;
  height: 40px;
  border-radius: 10px;
}

#btnEditar:hover {
  background-color: #e8af06;
  transform: scale(1.05);
}

/* Botón de eliminación */
#btnEliminar {
  font-size: 18px;
  width: 50px;
  height: 40px;
  border-radius: 10px;
  color: black;
}

#btnEliminar:hover {
  background-color: #b72433;
  transform: scale(1.05);
}

/* Estilo de la búsqueda */
.busqueda {
  padding: 10px;
  font-size: 14px;
  border-radius: 10px;
  border-width: 0.5px;
  width: 100%;
  max-width: 300px;
}

input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #c09d62;
  box-shadow: 0 0 0 3px rgba(192, 157, 98, 0.2);
  transition: all 0.3s ease;
}

/* Selección */
select {
  border: 1px solid #ccc;
  margin: 10px 5px;
  width: 60px;
  height: 35px;
  border-radius: 5px;
}

/* Contenedor de proveedores */
.proveedores-wrapper {
  padding: 16px;
  width: 100%;
  overflow-x: hidden;
}

/* Contenedor de tabla */
.table-container {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ddd;
  margin-top: 16px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

/* Estilo de la tabla */
.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

.table th,
.table td {
  padding: 6px 8px;
  text-align: center;
  font-size: 0.875rem;
  white-space: nowrap;
}

.table thead th {
  border-bottom: 1px solid #ddd;
}

.table tbody td {
  border-top: 1px solid #ddd;
}

.table thead th:first-child {
  border-top-left-radius: 10px;
}

.table thead th:last-child {
  border-top-right-radius: 10px;
}

.table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

.table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

/* ✅ Anchos de columnas actualizados */
.col-id {
  width: 8%;
}

.col-nombre {
  width: 15%;
}

.col-rtn {
  width: 12%;
}

.col-telefono {
  width: 10%;
}

.col-email {
  width: 15%;
}

.col-direccion {
  width: 30%;
}

.col-acciones {
  width: 10%;
}

/* Botones de acción en tabla */
.accion-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  font-size: 0.8rem;
  margin: 0 2px;
  transition: opacity 0.15s, transform 0.15s;
}
.accion-btn:hover { opacity: .85; transform: scale(1.08); }

.btn-editar   { background: #f59e0b; color: #111; }
.btn-eliminar { background: #ef4444; }

.action-buttons {
  display: flex;
  gap: 12px;
}

.phone-input-container {
  display: flex;
  gap: 8px;
}

.phone-input-container select {
  width: 110px;
  margin: 0;
  height: 35px;
  padding: 0 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.phone-input-container input {
  flex: 1;
  height: 35px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Estilos para modo oscuro */
.dark .country-code-select,
.dark .phone-input {
  background-color: #383838;
  border-color: #404040;
  color: #fff;
}

/* Estilo para scroll personalizado */
.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c09d62;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}

/* Media Queries Mejoradas */

/* Pantallas grandes */
@media screen and (max-width: 1200px) {
  .modal-proveedores {
    width: 70%;
  }

  .table-container {
    margin-top: 14px;
  }
}

/* Tablets y pantallas medianas */
@media screen and (max-width: 768px) {
  .proveedores-wrapper {
    padding: 12px;
  }

  /* Layout de opciones */
  .opciones {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  #btnAdd {
    width: 100%;
    margin: 0;
  }

  .busqueda {
    max-width: none;
  }

  /* Tabla responsiva */
  .table-container {
    margin-top: 16px;
    border-radius: 8px;
    overflow-x: auto;
  }

  .table {
    min-width: 750px;
  }

  /* Ajustes modales */
  .modal-proveedores {
    width: 90%;
    margin: 10px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-confirm {
    width: 80%;
  }

  /* Formularios */
  .contenedor {
    width: 100%;
  }

  .form-group {
    margin-bottom: 12px;
  }

  /* Botones de acción */
  #btnEditar,
  #btnEliminar {
    width: 36px;
    height: 36px;
    font-size: 16px;
    padding: 6px;
  }
}

/* Móviles */
@media screen and (max-width: 480px) {
  .proveedores-wrapper {
    padding: 10px;
  }

  /* Convertir tabla en tarjetas */
  .table {
    display: block;
    min-width: unset;
    border: none;
  }

  .table thead {
    display: none;
  }

  .table tbody {
    display: block;
  }

  .table tr {
    display: block;
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #fff;
  }

  .table td {
    display: grid;
    grid-template-columns: 40% 60%;
    padding: 8px 4px;
    text-align: left;
    border: none;
    font-size: 14px;
  }

  .table td::before {
    content: attr(data-label);
    font-weight: bold;
    color: #666;
  }

  /* Modo oscuro para tarjetas */
  .dark .table tr {
    background: #2d2d2d;
    border-color: #404040;
  }

  .dark .table td::before {
    color: #aaa;
  }

  /* Columna de acciones */
  .table td:last-child {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 12px;
    margin-top: 8px;
    border-top: 1px solid #eee;
    grid-column: 1 / -1;
  }

  .dark .table td:last-child {
    border-top-color: #404040;
  }

  /* Input de teléfono responsivo */
  .phone-input-container {
    flex-direction: column;
    gap: 8px;
  }

  .phone-input-container select,
  .phone-input-container input {
    width: 100%;
  }

  /* Ajustes modales */
  .modal-proveedores {
    width: 95%;
    margin: 8px;
  }

  .modal-header {
    padding: 16px;
  }

  .modal-body {
    padding: 12px;
  }

  .h2-modal-proveedores {
    font-size: 18px;
  }
}

/* Móviles pequeños */
@media screen and (max-width: 360px) {
  .table td {
    grid-template-columns: 100%;
  }

  .table td::before {
    margin-bottom: 4px;
  }

  .table td:last-child {
    justify-content: center;
  }

  #btnEditar,
  #btnEliminar {
    width: 32px;
    height: 32px;
  }

  .modal-header h2 {
    font-size: 1.1rem;
  }

  .form-group label {
    font-size: 13px;
  }
}

/* Landscape mode */
@media screen and (max-height: 480px) and (orientation: landscape) {
  .modal-proveedores {
    max-height: 100vh;
    margin: 0;
  }

  .modal-body {
    max-height: calc(100vh - 120px);
  }

  .form-group {
    margin-bottom: 8px;
  }

  .phone-input-container {
    flex-direction: row;
  }

  .form-group input,
  .form-group select {
    padding: 8px;
  }
}

/* =======================================================
   Modo Oscuro
======================================================= */
/* Contenedor principal */
.dark .categorias-wrapper {
  background-color: #1e1e1e;
  color: #fff;
}

.dark .modal-proveedores,
.dark .modal-confirm {
  background-color: #2d2d2d;
}

/* Inputs y búsqueda en modo oscuro */
.dark .busqueda {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #fff;
}

.dark .custom-select {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #fff;
}

.dark .custom-select option {
  background-color: #2d2d2d;
  color: #fff;
}

/* Tabla en modo oscuro */
.dark .table-container {
  background-color: #1e1e1e;
  border-color: #374151;
}

.dark .table {
  background-color: #1e1e1e;
}

.dark .table thead {
  background-color: #111827;
}

.dark .table th {
  background-color: #111827;
  color: #e5e7eb;
  border-bottom-color: #374151;
}

.dark .table td {
  color: #e5e7eb;
  border-bottom-color: #374151;
}

.dark .table tbody tr:hover {
  background-color: #1f2937;
}

/* Scroll personalizado en modo oscuro */
.dark .table-container::-webkit-scrollbar-track {
  background: #2d2d2d;
}

.dark .table-container::-webkit-scrollbar-thumb {
  background: #c09d62;
}

.dark .table-container::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}

/* Botones en modo oscuro */
.dark #btnAdd {
  background-color: #c09d62;
  color: black;
}

.dark #btnAdd:hover {
  background-color: #a38655;
}

.dark #btnEditar {
  background-color: #ffc107;
  color: black;
}

.dark #btnEditar:hover {
  background-color: #e8af06;
}

.dark #btnEliminar {
  background-color: #dc3545;
  color: black;
}

.dark #btnEliminar:hover {
  background-color: #b72433;
}

/* Paginación */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  margin-top: auto;
}

.pagination-info {
  color: #6c757d;
}

.pagination-container {
  display: flex;
  gap: 5px;
}

.pagination-button {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background-color: white;
  cursor: pointer;
  border-radius: 4px;
  min-width: 40px;
  transition: all 0.3s ease;
}

.pagination-button:hover:not(:disabled) {
  background-color: #e9ecef;
}

.pagination-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Paginación en modo oscuro */
.dark .pagination-wrapper {
  border-color: #404040;
}

.dark .pagination-info {
  color: #aaa;
}

.dark .pagination-button {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #fff;
}

.dark .pagination-button:hover:not(:disabled) {
  background-color: #383838;
}

/* Media Queries para paginación */
@media screen and (max-width: 768px) {
  .pagination-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .pagination-container {
    justify-content: center;
    flex-wrap: wrap;
  }
}

/* Estilos para indicadores */
.loading-indicator,
.no-data {
  text-align: center;
  padding: 2rem;
  font-size: 1.1rem;
  color: #666;
}

.dark .loading-indicator,
.dark .no-data {
  color: #aaa;
}
</style>